<template>
  <div>
    <el-col
      :span="24"
      class="interactive-test-container"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :style="{ height: height + 'px !important' }"
    >
      <iframe
        ref="testIframe"
        :src="url"
        id="interactive_test_iframe"
        width="100%"
        :height="height + 'px'"
        frameborder="0"
        allowfullscreen="true"
        allow="camera; microphone; fullscreen; display-capture; autoplay"
        @load="handleIframeLoaded"
      ></iframe>
    </el-col>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "InteractiveTestViewer",
  props: {
    url: {
      required: true,
      type: String,
    },
    height: {
      required: false,
      type: Number,
      default: 500,
    },
    lessonId: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    url(newVal) {
      if (newVal) {
        this.loading = true;
      }
    },
  },
  methods: {
    handleIframeLoaded() {
      this.loading = false;
      this.$emit("loaded");
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.testIframe) {
        this.$refs.testIframe.onload = () => {
          this.handleIframeLoaded();
        };
      }
    });
  },
};
</script>

<style scoped>
.interactive-test-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.8);
}
.interactive-test-container iframe {
  display: block;
  border: none;
}
</style>
